import { map, mergeMap, pipe, subscribe, tap } from 'wonka';
import { processCommands } from './command';
import { getEnvironment } from './environment';
import { initialise$ } from './initialise';
import { domContentLoaded$ } from './utils/events';

/**
 * Entrypoint for spinning up the front end of the tagService code
 * Wait for our content loaded event and kick off our initialisation flow
 * and start to process 'commands' (events that can come from our back end)
 * or other sources
 */
export const launch = () => {
  const environment = getEnvironment(window);

  pipe(
    domContentLoaded$(environment.currentWindow),
    map(() => 'Initialise'),
    mergeMap(initialise$),
    subscribe(processCommands),
  );
};
